// TODO: Consider using Partial<T> to better handling incremental config

export interface BaseConfigType {
  username?: string;
  serial?: string;
}

export interface CredentialType {
  password?: string;
}

export interface ProvisioningContextType {
  serial?: string;
}

export enum ServiceName {
  ASKR = "ASKR",
  MIDGARD = "MIDGARD",
}
